import { render, staticRenderFns } from "./CronogramaEstudio.vue?vue&type=template&id=56ffd804&"
import script from "./CronogramaEstudio.vue?vue&type=script&lang=js&"
export * from "./CronogramaEstudio.vue?vue&type=script&lang=js&"
import style0 from "./CronogramaEstudio.vue?vue&type=style&index=0&id=56ffd804&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports